"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebrtcConnectorRpcRemote = void 0;
const utils_1 = require("@streamr/utils");
const RpcRemote_1 = require("../../dht/contact/RpcRemote");
const logger = new utils_1.Logger(module);
class WebrtcConnectorRpcRemote extends RpcRemote_1.RpcRemote {
    requestConnection() {
        const request = {};
        const options = this.formDhtRpcOptions({
            notification: true
        });
        this.getClient().requestConnection(request, options).catch((_e) => {
            logger.trace('Failed to send requestConnection');
        });
    }
    sendRtcOffer(description, connectionId) {
        const request = {
            connectionId,
            description
        };
        const options = this.formDhtRpcOptions();
        this.getClient().rtcOffer(request, options).catch((_e) => {
            logger.trace('Failed to send rtcOffer');
        });
    }
    sendRtcAnswer(description, connectionId) {
        const request = {
            connectionId,
            description
        };
        const options = this.formDhtRpcOptions();
        this.getClient().rtcAnswer(request, options).catch((_e) => {
            logger.trace('Failed to send rtcAnswer');
        });
    }
    sendIceCandidate(candidate, mid, connectionId) {
        const request = {
            connectionId,
            mid,
            candidate
        };
        const options = this.formDhtRpcOptions();
        this.getClient().iceCandidate(request, options).catch((_e) => {
            logger.trace('Failed to send iceCandidate');
        });
    }
}
exports.WebrtcConnectorRpcRemote = WebrtcConnectorRpcRemote;
//# sourceMappingURL=WebrtcConnectorRpcRemote.js.map